export default __webpack_public_path__ + "static/media/RangeBadge1.4bf3cc16.png";